export default [
  {
    path: '/road-closure-alerts',
    redirect: to => {
      return { path: '/service-alerts', query: to.query, hash: to.hash }
    }
  },
  {
    path: '/road-closure-alerts/create',
    redirect: to => {
      return { path: '/service-alerts/subscribe', query: to.query, hash: to.hash }
    }
  },
  {
    path: '/road-closure-alerts/unsubscribe',
    redirect: to => {
      return { path: '/service-alerts/unsubscribe', query: to.query, hash: to.hash }
    }
  },
  {
    path: '/road-closure-alerts/verification',
    redirect: to => {
      return { path: '/service-alerts/verification', query: to.query, hash: to.hash }
    }
  },
  {
    path: "/service-alerts",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    children: [
      {
        path: "",
        redirect: { name: "RCCreate" }
      },
      {
        path: "verification",
        name: "RCSubscription",
        component: () =>
          import("@/views/RoadClosureAlerts/SubscriptionVerification.vue")
      },
      {
        path: "unsubscribe",
        name: "RCUnsubscribe",
        component: () =>
          import("@/views/RoadClosureAlerts/UnsubscribeVerification.vue")
      },
      {
        path: "subscribe",
        name: "RCCreate",
        component: () => import("@/views/RoadClosureAlerts/Create.vue")
      }
    ]
  }
];
